export default __webpack_public_path__ + "static/media/other_persons_in_household.b6428789.svg";